<template>
  <div class="agent_item">
    <div class="agent_head">
      <img
        src="../../../assets/img/user_img.jpg"
        class="img"
      />
    </div>

    <div class="agent_name mgt50 pdl20">{{ detail.name }}</div>
    <div class="agent_email pdl20 mgt10">Account：<div class="detail-email"> {{ detail.email }}</div>
    </div>

    <div class="agent_op pdb10">
      <el-switch
        class="pdl20"
        v-model="switchSatate"
        @change="changeStatus"
        active-color="#47B959"
        inactive-color="#999999"
      >
      </el-switch>
      <div class="d_flex pdr20">
        <el-popconfirm
          confirm-button-text="Confirm"
          cancel-button-text="Cancel"
          icon="el-icon-info"
          icon-color="red"
          title="Are you sure to delete account?"
          @confirm="agentDelete"
        >
          <el-button
            slot="reference"
            type="text"
          >
            <div class="agent_op_delete">
              <img
                src="../../../assets/img/icon_delete.png"
                class="img"
              />
            </div>
          </el-button>
        </el-popconfirm>
        <el-button type="text">
          <div
            class="agent_op_edit mgl10"
            @click="agentEdit"
          >
            <img
              src="../../../assets/img/icon_edit.png"
              class="img"
            />
          </div>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { updateAgentState, deleteAgent } from '@/api/agent/agent'

export default {
  props: {
    detail: {}
  },
  data() {
    return {
      switchSatate: false
    }
  },
  watch: {
    detail: {
      handler(newVal, oldVal) {
        if (newVal) {
          const { state } = newVal
          if (state === 'ACTIVE') {
            this.switchSatate = true
          } else {
            this.switchSatate = false
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() { },
  methods: {
    changeStatus(e) {
      console.log('changeStatus:', e)
      const { id } = this.detail
      const params = {
        state: e === true ? 0 : 1
      }
      updateAgentState(id, params)
        .then((res) => {
          console.log('updateState res:', res)
          if (e) {
            this.$message.success('Successfully!')
          }
        })
        .catch()
    },
    agentDelete() {
      const { id } = this.detail
      console.log('delete id:', id)
      deleteAgent(id)
        .then((res) => {
          console.log('delete res:', res)
          this.$emit('delete')
        })
        .catch()
    },
    agentEdit() {
      this.$emit('edit')
    }
  }
}
</script>

<style scoped lang="scss">
.agent_item {
  width: 280px;
  height: 165px;
  background: #ffffff;
  border-radius: 8px;
  position: relative;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: start;

  .agent_head {
    width: 80px;
    height: 80px;
    border-radius: 80px;
    position: absolute;
    top: -40px;
    left: 20px;

    .img {
      width: 80px;
      height: 80px;
    }
  }

  .agent_name {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    text-align: center;
    font-style: normal;
  }

  .agent_email {
    width: 240px;
    display: flex;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #000000;
    text-align: center;
    font-style: normal;
  }
  .detail-email {
    width: 190px;
    overflow: hidden;
    text-align: left;
    word-wrap: break-word;
  }
  .agent_op {
    width: 100%;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    bottom: 0;

    .agent_op_delete {
      width: 34px;
      padding: 6px 2px;
      background: #ffffff;
      border-radius: 16px;
      border: 1px solid #e85353;
      display: flex;
      align-items: center;
      justify-content: center;

      .img {
        width: 16px;
        height: 16px;
      }
    }

    .agent_op_edit {
      width: 34px;
      padding: 6px 2px;
      background: #200e32;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      .img {
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
